module.exports = __webpack_public_path__ + "img/Beijing_Life.78923b5a.jpg";